import { useMutation } from '@gogame/query';

import { exportCSV } from 'scenes/MarketingPlanning/MarketingPlanningGrid/sources/marketingPlanning';

import { exportCSV as exportCSVkey } from '../queryKeyFactory';

export const useExportCSV = () => {
  const exportMutation = useMutation(exportCSVkey(), exportCSV, {
    refresh: false,
    successMessage: () => 'Plan export completed',
  });

  return [exportMutation.mutateAsync, exportMutation];
};
